export enum AadeInvoiceClassificationStatus {
NotClassified,
PartiallyClassified,
Classified,
}
